import { useState } from "react";
import styles from "./styles.module.css";
import Modal from "react-responsive-modal";
import Table from "../../../components/TableConstructor";
import { MetaAplicacaoRecurso } from "../../../model/PlanoDeTrabalho/PlanoAplicacao";
import RowAplicacaoRecurso from "../../../components/TableConstructor/Row/RowAplicacaoRecurso";
import ModalAplicacaoRecurso from "../../../components/ModalForms/ModalAplicacaoRecurso";
import { MetaFisica } from "../../../model/PlanoDeTrabalho/CronogramaExecucao";

type Props = {
  passarPagina: Function;
  voltarPagina: Function;
  listaAplicacoes: MetaAplicacaoRecurso[];
  setMetas: React.Dispatch<React.SetStateAction<MetaAplicacaoRecurso[]>>;
  title: string;
  listaMetas: MetaFisica[];
  tipo: string;
};

function AplicacaoTab({
  passarPagina,
  voltarPagina,
  listaAplicacoes,
  setMetas,
  title,
  listaMetas,
  tipo,
}: Props) {
  const [showModal, setModal] = useState(false);
  const [showEditModelIndex, setEditModalIndex] = useState(-1);

  return (
    <div>
      <h2 className={styles.titulo}>{title}</h2>

      <Table
        listTitle={[
          "Etapa/Fase",
          "Especificação",
          "Indicador",
          "Custo",
          "Recursos",
          "",
        ]}
        styleList={[1, 0, 1, 1, 1, 0]}
      >
        {listaAplicacoes.map((appObj, index) => (
          <RowAplicacaoRecurso key={index} appObj={appObj}>
            <button
              className={styles.btn}
              onClick={(e) => {
                e.preventDefault();
                setEditModalIndex(index);
              }}
            >
              Editar
            </button>
            <Modal
              open={showEditModelIndex === index}
              onClose={() => setEditModalIndex(-1)}
              center
              classNames={{
                modal: "customModal",
              }}
            >
              <ModalAplicacaoRecurso
                refMeta={appObj}
                closeModal={() => setEditModalIndex(-1)}
                list={listaAplicacoes}
                setList={setMetas}
                listaMetas={listaMetas}
                tipo={tipo}
                index={index}
              />
            </Modal>
          </RowAplicacaoRecurso>
        ))}
      </Table>
      <div className={styles.addDiv}>
        <button
          className={styles.addBtn}
          onClick={(e) => {
            e.preventDefault();
            setModal(true);
          }}
        >
          + Adicionar Meta
        </button>
      </div>
      <Modal
        open={showModal}
        onClose={() => setModal(false)}
        center
        classNames={{
          modal: "customModal",
        }}
      >
        <ModalAplicacaoRecurso
          closeModal={() => setModal(false)}
          list={listaAplicacoes}
          setList={setMetas}
          listaMetas={listaMetas}
          tipo={tipo}
        />
      </Modal>

      <div className="flex justify-between">
        <button
          className={styles.passarTelaBtn}
          onClick={() => {
            voltarPagina();
          }}
        >
          ❮❮ Anterior
        </button>
        <button
          className={styles.passarTelaBtn}
          onClick={() => {
            passarPagina();
          }}
        >
          Proximo ❯❯
        </button>
      </div>
    </div>
  );
}

export default AplicacaoTab;
